import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Register, NodeViewComponent } from '@xanadu/core';
import { Node, Group, User, NodeModel } from '@xanadu/model';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-user-view',
    templateUrl: './user-view.component.html',
    styleUrls: ['./user-view.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
@Register('user-view')
export class UserViewComponent extends NodeViewComponent<User | Group> {

    protected get nodeType(): string | undefined {
        return 'user';
    }

    protected getPanel(model: NodeModel) {
        const node = model.node;

        if (node instanceof Group) {
            return {
                node: node,
                component: 'group-panel'
            };
        } else {
            return {
                node: node,
                component: 'user-panel'
            };
        }
    }

    protected delete(node: Node): Observable<User | Group> {
        return this.dataService.delete<User | Group>(node as any);
    }
}
